import styled from 'styled-components';
import { GiPartyPopper } from 'react-icons/gi';
import { BiChurch } from 'react-icons/bi';
import { BrowserRouter } from 'react-router-dom';

import WeddingImg from './assets/place-1.jpg';
import ReceptionImg from './assets/place-2.jpg';
import Gallery1Img from './assets/gallery-1.jpg';
import Gallery2Img from './assets/gallery-2.jpg';
import ConfirmationImg from './assets/rsvp.jpg';
import Hero from './Hero';
import Intro from './Intro';
import Place from './Place';
import DressCode from './DressCode';
import Confirmation from './Confirmation';
import Gallery from './Gallery';
import Copyright from './Copyright';

const App = () => {
  const wedding = {
    title: 'CEREMONIA RELIGIOSA',
    name: 'Catedral Basílica Menor de la Inmaculada Concepción',
    address: 'Av. 20 de Noviembre s/n, Zona Centro, 34000 Durango, Dgo.',
    time: '17:00 Horas',
    link: 'https://maps.app.goo.gl/oZQzNhea272npFVX9?g_st=iw'
  };

  const reception = {
    title: 'RECEPCIÓN',
    name: 'Hacienda La Galera',
    address: '34330 Dgo.',
    time: '19:30 Horas',
    link: 'https://maps.app.goo.gl/n6bM4feCre5bWVkw6?g_st=iw'
  };

  return (
    <BrowserRouter basename='/'>
      <AppContainer>
        <Hero />
        <Intro />
        <Place
          place={wedding}
          icon={<BiChurch className='placeIcon' />}
          image={WeddingImg}
          imageFirst={true}
        />
        <Place
          place={reception}
          icon={<GiPartyPopper className='placeIcon' />}
          image={ReceptionImg}
          imageFirst={false}
        />
        <DressCode />
        <Confirmation img={ConfirmationImg} />
        <Gallery images={[Gallery1Img, Gallery2Img]}></Gallery>
        <Copyright />
      </AppContainer>
    </BrowserRouter>
  );
};

export default App;

const AppContainer = styled.main`
  overflow-x: hidden;
`;
